import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0f52b091")

_pushScopeId("data-v-0f52b091")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Calendario")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = { class: "container_appuntamenti" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "container_selected_day" }
const _hoisted_7 = { class: "selected_day" }
const _hoisted_8 = {
  key: 0,
  class: "empty_events_container"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "empty_events" }, "Nessun evento da visualizzare", -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "cliente_info" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "time" }
const _hoisted_14 = {
  key: 0,
  class: "partecipants_count"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadData()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  (!$setup.loading)
                    ? (_openBlock(), _createBlock("div", _hoisted_5, [
                        _createVNode(_component_Calendar, {
                          value: $setup.date,
                          attributes: $setup.setAttributes,
                          onDayclick: $setup.dayClicked,
                          "onUpdate:fromPage": $setup.loadCurrentMonthData,
                          "is-expanded": "",
                          class: "calendar_container"
                        }, null, 8, ["value", "attributes", "onDayclick", "onUpdate:fromPage"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_6, [
                    _createVNode("div", _hoisted_7, _toDisplayString($setup.selectedDay && $setup.selectedDay.id ? $setup.dateFormat($setup.selectedDay.id) : $setup.dateFormat($setup.date)), 1),
                    ($setup.eventsToShow.length == 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_8, [
                          _hoisted_9
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_10, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.eventsToShow, (event) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "event",
                              key: event.events_id,
                              onClick: ($event: any) => ($setup.openDetailModal(event))
                            }, [
                              _createVNode("div", {
                                class: "fake_border",
                                style: {
                                        width: '8px',
                                        borderRadius: '4px',
                                        backgroundColor: `${event.events_box_color}`,
                                    }
                              }, null, 4),
                              _createVNode("div", _hoisted_11, [
                                _createVNode("div", _hoisted_12, _toDisplayString(event.events_title), 1),
                                _createVNode("div", _hoisted_13, [
                                  _createVNode("div", null, _toDisplayString($setup.timeFormat(event.events_date_start)) + " - " + _toDisplayString($setup.timeFormat(event.events_date_end)), 1),
                                  (event.events_requires_confirmation && event.partecipants_count)
                                    ? (_openBlock(), _createBlock("div", _hoisted_14, [
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: ['fas', 'users'],
                                          style: {"color":"#7f8085","font-size":"12px"}
                                        }),
                                        _createVNode("span", null, _toDisplayString(event.partecipants_count && event.partecipants_count > 0 ? event.partecipants_count : ''), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ], 8, ["onClick"]))
                          }), 128))
                        ]))
                  ])
                ])
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})